import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllBonusStart } from '../../store/redux-slices/admins'
import { getAllTABonusStart, getBonusStart, getSegmentsStart, getTABonusStart, issueBonusStart } from '../../store/redux-slices/bonus'
import { getAllCasinoGamesStart } from '../../store/redux-slices/superAdminCasinoManagement'
import { getAllMasterGamesStart } from '../../store/redux-slices/tenantCasino'
import { getAllCasinoGames, getMasterGames } from '../../utils/apiCalls'
import { safeStringify } from '../../utils/helpers'

const useBonusIssue = (isTenant, issueType, setShowModal) => {
  const dispatch = useDispatch()
  const [selectedClient, setSelectedClient] = useState('')
  const [selectedPortal, setSelectedPortal] = useState('')
  const [selectedBonus, setSelectedBonus] = useState('')
  const { bonusList, loading: bonusLoading } = useSelector((state) => state.admins)
  const [segmentsOptions, setSegmentOptions] = useState([])
  const [excludeSegmentsOptions, setExcludeSegmentOptions] = useState([])
  const [search, setSearch] = useState('')
  const [gameIds, setGameIds] = useState([])
  const [gamesData, setGamesData] = useState([])
  const { masterGames, loading: tenantLoading } = useSelector(state => state.tenantCasino)
  const { casinoGamesData, loading: superAdminLoading } = useSelector(state => state.superAdminCasino)
  const { bonusList: TABonusList, loading: TABonusLoading, bonusDetail, segments } = useSelector((state) => state.bonus)

  useEffect(() => {
    async function fetchData () {
      isTenant
        ? await getMasterGames({
          limit: '',
          pageNo: '',
          search: '',
          casinoCategoryId: '',
          providerId: '',
          freespins: true,
          bonusId: ''
        }).then((res) => {
          setGamesData(res?.data?.data?.casinoGames)
        })
        : await getAllCasinoGames({
          limit: '',
          pageNo: '',
          casinoCategoryId: '',
          search: '',
          isActive: '',
          tenantId: '',
          selectedProvider: '',
          freespins: true,
          bonusId: ''
        }).then((res) => {
          setGamesData(res?.data?.data?.casinoGames)
        })
    }
    issueType === 'freespin' && fetchData()
  }, [])

  useEffect(() => {
    if (issueType === 'bonus') {
      !isTenant
        ? selectedPortal && dispatch(getAllBonusStart({
          adminId: selectedClient,
          tenantId: selectedPortal,
          bonusType: safeStringify(['deposit', 'balance', 'wagering'])
        }))
        : dispatch(getAllTABonusStart({
          limit: '',
          pageNo: '',
          search: '',
          isActive: '',
          bonusType: safeStringify(['deposit', 'balance', 'wagering'])
        }))
    } else {
      (selectedPortal || isTenant) && dispatch(getSegmentsStart({ isTenant }))
      if (isTenant) {
        dispatch(getAllTABonusStart({
          limit: '',
          pageNo: '',
          search: '',
          bonusType: safeStringify(['freespins']),
          isActive: '',
          userId: ''
        }))
      } else {
        selectedPortal && dispatch(getAllBonusStart({
          adminId: selectedClient,
          tenantId: selectedPortal,
          limit: '',
          pageNo: '',
          search: '',
          bonusType: safeStringify(['freespins']),
          isActive: '',
          userId: ''
        }))
      }
    }
    setSelectedBonus('')
  }, [selectedPortal])

  useEffect(() => {
    if (selectedBonus?.bonusId && issueType === 'bonus') {
      isTenant
        ? dispatch(getTABonusStart({ bonusId: selectedBonus?.bonusId, userBonusId: '' }))
        : dispatch(getBonusStart({ bonusId: selectedBonus?.bonusId, isTenant: false, userBonusId: '' }))
    }
  }, [selectedBonus])

  useEffect(() => {
    if (issueType === 'bonus') {
      const BList = isTenant ? TABonusList : bonusList
      if (BList?.length) {
        setSelectedBonus(BList?.[0])
        dispatch(getSegmentsStart({ isTenant }))
      } else {
        setSelectedBonus('')
      }
    } else {
      updateBonusOptions()
    }
  }, [bonusList, TABonusList])

  useEffect(() => {
    let options = []
    if (segments?.length) {
      options = segments.map((item) => { return ({ label: `${item.name} (${item.id})`, value: item.id }) })
      setSegmentOptions(options)
      setExcludeSegmentOptions(options)
    }
  }, [segments])

  const issueBonusHandler = (data) => {
    dispatch(issueBonusStart({ data, isTenant, handleIssue, user: false }))
  }

  const handleIssue = () => {
    setShowModal(false)
    setSelectedBonus('')
    setSelectedClient('')
    setSelectedPortal('')
    setGameIds([])
    setGamesData([])
    setSearch('')
  }

  const getTAGames = () => {
    dispatch(
      getAllMasterGamesStart({
        limit: '',
        pageNo: '',
        search,
        casinoCategoryId: '',
        providerId: '',
        freespins: true
      })
    )
  }

  const getSAGames = () => {
    dispatch(
      getAllCasinoGamesStart({
        limit: '',
        pageNo: '',
        casinoCategoryId: '',
        search,
        isActive: '',
        tenantId: '',
        selectedProvider: '',
        freespins: true,
        bonusId: ''
      })
    )
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      isTenant
        ? getTAGames()
        : getSAGames()
    }, 1000)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  const handleSelect = (e, id) => {
    if (!e.target.checked) {
      setGameIds(gameIds.filter(gameId => gameId !== id))
    } else {
      const data = [...gameIds]
      data.unshift(id)
      setGameIds(data)
    }
  }

  const availableGames = casinoGamesData || masterGames
  const getData = (type, gameId) => {
    const data = gamesData?.find((game) => game.casinoGameId === gameId)
    if (type === 'name') {
      return data?.name
    } else {
      return data?.casinoGameId
    }
  }

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const data = [...gameIds]
      for (const index in availableGames) {
        const id = availableGames?.[index]?.casinoGameId
        !data.includes(id) && data.push(id)
      }
      setGameIds(data)
    } else {
      let data = [...gameIds]
      for (const index in availableGames) {
        const gameId = availableGames?.[index]?.casinoGameId
        data = data.filter(id => id !== gameId)
      }
      setGameIds(data)
    }
  }

  const [bonusOptions, setBonusOptions] = useState([])
  const updateBonusOptions = () => {
    if (!isTenant && bonusList?.length > 0) {
      const bonusOpt = []
      bonusList.forEach(function (element) {
        bonusOpt.push({ label: `${element.promotionTitle?.EN} (${element.bonusId})`, value: element.bonusId })
      })
      setBonusOptions(bonusOpt)
    } else if (TABonusList?.length > 0) {
      const bonusOpt = []
      TABonusList.forEach(function (element) {
        bonusOpt.push({ label: `${element.promotionTitle?.EN} (${element.bonusId})`, value: element.bonusId })
      })
      setBonusOptions(bonusOpt)
    }
  }

  return {
    selectedBonus,
    setSelectedBonus,
    bonusList: isTenant ? TABonusList : bonusList,
    bonusDetail,
    issueBonusHandler,
    selectedClient,
    selectedPortal,
    setSelectedClient,
    setSelectedPortal,
    TABonusLoading,
    bonusLoading,
    segmentsOptions,
    search,
    setSearch,
    gameIds,
    availableGames,
    handleSelectAll,
    handleSelect,
    getData,
    loading: isTenant ? tenantLoading : superAdminLoading,
    bonusOptions,
    excludeSegmentsOptions,
    setExcludeSegmentOptions
  }
}

export default useBonusIssue
